import { type ReactNode } from 'react'

import i18n from 'i18next'
import { I18nextProvider } from 'react-i18next'
import { useParams } from 'src/lib/hooks'
import { Language, treatExternalLocale } from 'src/lib/utils'

const getI18nInstance = (lang: Language): typeof i18n => {
  const instance = i18n.createInstance()

  instance.init({
    debug: process.env.NODE_ENV === 'development',
    resources: {
      [lang]: require(`../../../public/locales/${lang}${lang === Language.PT ? '_BR' : ''}`)
    },
    lng: treatExternalLocale(lang),
    load: 'currentOnly',
    fallbackLng: Language.EN,
    interpolation: {
      escapeValue: false
    },
    returnNull: false,
    returnEmptyString: false
  })

  return instance
}

const I18nProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const { lang } = useParams()

  return (
    <I18nextProvider i18n={getI18nInstance(treatExternalLocale(lang))}>{children}</I18nextProvider>
  )
}

export default I18nProvider
